var exports = {
  "i": "x8b4e8595--547e01--wrapper",
  "g": "x8b4e8595--547e01--newbuilding-recommendations-banners-container",
};

module.exports = exports;
